import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 16"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("g", { "clip-path": "url(#i1887738220__a)" }, [
      _createElementVNode("path", {
        stroke: "#FEB522",
        d: "M6.103 3.605C6.947 2.091 7.369 1.333 8 1.333c.631 0 1.053.758 1.898 2.272l.219.392c.24.431.36.646.546.788.187.142.42.195.887.3l.424.096c1.64.372 2.46.557 2.655 1.184.194.627-.365 1.281-1.482 2.588l-.29.338c-.317.372-.476.558-.548.787-.071.23-.047.478 0 .973l.045.452c.168 1.744.253 2.616-.258 3.004-.51.387-1.278.034-2.813-.673l-.398-.183c-.436-.201-.654-.301-.885-.301-.232 0-.45.1-.886.301l-.397.183c-1.535.707-2.303 1.06-2.813.673-.512-.388-.427-1.26-.258-3.004l.044-.451c.048-.496.072-.744 0-.973-.07-.23-.23-.416-.548-.787l-.289-.339c-1.118-1.306-1.677-1.96-1.482-2.588.195-.627 1.015-.813 2.655-1.184l.424-.096c.466-.105.7-.158.886-.3.188-.142.307-.357.547-.788l.219-.392Z"
      })
    ], -1),
    _createElementVNode("defs", null, [
      _createElementVNode("clipPath", { id: "i1887738220__a" }, [
        _createElementVNode("path", {
          fill: "#fff",
          d: "M0 0h16v16H0z"
        })
      ])
    ], -1)
  ]))]))
}
export default { render: render }